import { Component, input } from '@angular/core';

import { SessionService } from "../../services/session.service";

@Component({
    selector: 'ism-svg',
    templateUrl: './ism-svg.component.html',
    standalone: false
})
export class IsmSvgComponent {
  readonly name = input<String>("Gear");
  readonly classString = input<string | undefined>(undefined);

  constructor(public session: SessionService) { };

}
